module.exports = __webpack_public_path__ + "static/map-model-9d6a5eed84ec013de41b63aa14838385.png";